import React from "react";
import { withPrefix } from "gatsby";

import Layout from "../components/Layout";
import Sidebar from "../components/Sidebar";
import config from "../../config";

import avatar from '../assets/images/avatar4.jpg';

const Named =({ data }) => (
  <Layout>
    <Sidebar />
    <div className="container-fluid p-0">
      <section
        className="resume-section p-lg-5 p-md-4 d-flex align-items-center"
        id="about"
      >
        <div className="w-100">
          <span className="d-block d-lg-none">
            <img
              className="img-fluid img-profile thumbnail mx-auto mb-2 border border-secondary"
              src={avatar}
              width="30%"
              border-width="100px"
              alt="A smiling headshot of me"
            />
          </span>
          <h2 className="mb-0">
            {config.firstName}
            <span className="text-primary">{config.lastName}</span>
          </h2>
          <div className="subheading mb-5">
            SHE/ HER/ HERS🙆🏽‍♀️
          </div>
          <div className="intro-container">
            <div className="introduction">

             <div className="announcement">
              <p style={{backgroundColor: 'lightblue'}}><b>I will be on the academic job market in Fall 2026</b>. I am excited about both postdoc and tenure-track faculty positions.
              </p>
            </div>

              <p className="lead">

                I am a Human-Computer Interaction (HCI) researcher working at the intersection of online governance, trust and safety issues 
                in the Global Majority. My research explores three key areas:
                <ul className="dissList">
                <li><b>coloniality</b> and <b>systemic issues</b> in online governance infrastructures</li>
                <li><b>cultural (in)sensitivity</b> in addressing harmful content in the Global Majority</li>
                <li><b>culturally-aligned</b> approaches to reimagine online governance futures</li>
                </ul>
                I am a final year PhD candidate in 
                <a
                  href="https://infosci.cornell.edu/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <span className="sym-icon"> Cornell Information Science</span>
                </a>{", "}
                 advised by Professor{" "}
                <a
                  href="https://www.adityavashistha.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon">Aditya Vashistha</span>
                </a>
                . In the past, I have worked with tech policy organization, such as  
                <a href="https://cdt.org/"
                target="_blank"
                rel="noopener noreferrer">
                <span className="sym-icon"> Center for Democracy and Technology. </span></a> 
                I completed my Bachelors and Masters in Computer Science and Engineering from 
                <a
                  href="https://cse.buet.ac.bd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon"> BUET</span>
                </a>
                , advised by Professor{" "}
                <a
                  href="https://sites.google.com/site/abmalimalislam/home"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon">A. B. M. Alim Al Islam.</span>
                </a>
                <br />
                <br />
                Apart from research, the following things keep me excited: books, concerts, jigsaw puzzles, and 
                <a
                  href="/world-foods"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                <span className="sym-icon"> fun food experiments</span> </a>.
              </p>

              <div className="social-icons">
                {config.socialLinks.map((social) => {
                  const { icon, url } = social;
                  return (
                    <a
                      key={url}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={icon}></i>
                    </a>
                  );
                })}
              </div>
            </div>

            <div className="news">
              <span className="recNews">
                <b>Recent News</b>
              </span>
              <ul class="fa-ul">
              <li>
                  <span class="fa-li">
                    <i class="fas fa-chalkboard-teacher"></i>
                  </span>
                  <b>Apr 26</b>: Presented two first authored papers at Barcelona, CHI2026.
              </li>               
              <li>
                  <span class="fa-li">
                    <i class="fas fa-pen"></i>
                  </span>
                  <b>Mar 26</b>: New paper accepted to CSCW2026.
              </li>               
              <li>
                  <span class="fa-li">
                    <i class="fas fa-microphone"></i>
                  </span>
                  <b>Feb 26</b>: Gave a talk at University of Rochester.
              </li>                
              <li>
                  <span class="fa-li">
                    <i class="fas fa-microphone"></i>
                  </span>
                  <b>Jan 26</b>: Gave a guest lecture at University of Exeter.
              </li>                                                                                          
              </ul>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-lg-5 p-md-4 d-flex justify-content-center"
        id="publication"
      >
        <div className="w-100">
          <h2 className="mb-5">Publications</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2026</h3>
              <ul className="papers">
              <li className="paper">               
                <span className="sym-icon">
                    Creating Group Rules with AI: Human‑AI Collaboration in WhatsApp Moderation.
                  </span>
                  <br />
                  Gauri Nayak, <span className="authorMe">Farhana Shahid</span>, Kiran Garimella, and Aditya Vashistha. 
                  <br/> 
                  Proceedings of the ACM on Human-Computer Interaction (CSCW 2026)
                </li> 
                <br/>

              <li className="paper">
                  <a
                    href="https://doi.org/10.1145/3772318.3791624"
                    target="_blank"
                    rel="noopener noreferrer"
                  >                     
                <span className="sym-icon">
                   LLMs Homogenize Values When Facilitating Constructive Arguments on Value‑Laden Topics.
                  </span></a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Stella Zhang, and Aditya Vashistha. 
                  <br/> 
                  ACM Conference on Human Factors in Computing Systems (CHI 2026) [
                  <a
                    href={withPrefix("https://arxiv.org/pdf/2509.10637")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ]
                </li> 
                <br/> 

              <li className="paper">
                  <a
                    href="https://doi.org/10.1145/3772318.3791553"
                    target="_blank"
                    rel="noopener noreferrer"
                  >                     
                <span className="sym-icon">
                   UnWEIRDing Peer Review in Human‑Computer Interaction.
                  </span></a>
                  <br />
                  <span className="authorMe">Farhana Shahid<sup>*</sup></span>, Hellina Hailu Nigatu<sup>*</sup>, Vishal Sharma, Abigail Oppong, Michaelanne Thomas, and Syed Ishtiaque Ahmed. 
                  <br/> 
                  ACM Conference on Human Factors in Computing Systems (CHI 2026) [
                  <a
                    href={withPrefix("https://www.arxiv.org/pdf/2601.17476")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ]
                </li> 
                <br/> 

              </ul>
            </div>
          </div>          

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2025</h3>
              <ul className="papers">
              <li className="paper">
                  <a
                    href="https://ojs.aaai.org/index.php/AIES/article/view/36719/38857"
                    target="_blank"
                    rel="noopener noreferrer"
                  >                     
                <span className="sym-icon">
                  Think Outside the Data: Colonial Biases and Systemic Issues in Automated Moderation Pipelines for Low‑Resource Languages. 
                  </span></a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Mona Elswah, and Aditya Vashistha. 
                  <br/> 
                  Proceedings of the Eighth AAAI/ACM Conference on AI, Ethics, and Society (AIES 2025) [
                  <a
                    href={withPrefix("https://arxiv.org/pdf/2501.13836")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] 
                  <br/>
                </li> 
                <br/> 

              <li className="paper">
                  <a
                    href="https://doi.org/10.1145/3757591"
                    target="_blank"
                    rel="noopener noreferrer"
                  >                    
                <span className="sym-icon">
                  Examining Human-AI Collaboration for Co-Writing Constructive Comments Online. 
                  </span></a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Maximilian Dittgen, Mor Naaman, and Aditya Vashistha. 
                  <br/> 
                  Proceedings of the ACM on Human-Computer Interaction (CSCW 2025) [
                  <a
                    href={withPrefix("https://arxiv.org/pdf/2411.03295")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] 
                  <br/>
                </li> 
                <br/> 

              <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3711042"
                    target="_blank"
                    rel="noopener noreferrer"
                  >                              
                <span className="sym-icon">
                  One Style Does Not Regulate All: Moderation Practices in Public and Private WhatsApp Groups 
                  </span></a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Dhruv Agarwal, and Aditya Vashistha. 
                  <br/> 
                  Proceedings of the ACM on Human-Computer Interaction (CSCW 2025) [
                  <a
                    href={withPrefix("https://arxiv.org/pdf/2401.08091")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] 
                  <br/>
                  <span class="sym-icon">
                  <i class="fas fa-award"></i>
                  <b> Best Student Paper (Social Media and Society in India)</b>
                </span>
                </li> 
                <br/>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2024</h3>
              <ul className="papers">

              <li className="paper">
                  <a
                    href="https://cdt.org/insights/colonialism-in-content-moderation-research-the-struggles-of-scholars-in-the-majority-world/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">Colonialism in Content Moderation Research: The Struggles of Scholars in the Majority World</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>
                  <br/> Center for Democracy and Technology
              </li> 
              <br/>

              <li className="paper">
                  
                  <a
                    href="https://dl.acm.org/doi/10.1145/3687030"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">Conversational Agents to Facilitate Deliberation on Harmful Content in WhatsApp Groups.</span>
                  </a>
                  <br />
                  Dhruv Agarwal, <span className="authorMe">Farhana Shahid</span>, and Aditya Vashistha. 
                  <br/> 
                  Proceedings of the ACM on Human-Computer Interaction (CSCW 2024) [
                  <a
                    href={withPrefix("https://arxiv.org/pdf/2405.20254")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ]
                   [
                  <a
                    href={"https://youtu.be/swAevS7GciE?si=FYoabPmr8JmmQDQo"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                  <br/>
                </li> 
                <br/>
              </ul>
            </div>
          </div>


          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2023</h3>
              <ul className="papers">
              <li className="paper">
                  <a
                    href="https://doi.org/10.1145/3544548.3581538"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">
                  Decolonizing Content Moderation: Does Uniform Global 
                  Community Standard Resemble Utopian Equality or Western Power Hegemony? 
                  </span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span> and Aditya Vashistha. 
                  <br/> 
                  ACM Conference on Human Factors in Computing Systems (CHI 2023) [
                  <a
                    href={withPrefix("/files/chi23-decolonial-moderation.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/Mb14Rkx8xyU"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                  <br/>
                </li> 
                <br/>
              </ul>
            </div>
          </div>


          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2022</h3>
              <ul className="papers">
              
              <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3491102.3517646"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">"It Matches My Worldview": Examining Perceptions and Attitudes Around Fake Videos.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid<sup>*</sup></span>, Srujana Kamath<sup>*</sup>, Annie Sidotam, Vivian Jiang, Alexa Batino, and Aditya Vashistha. 
                  <br/> ACM Conference on Human Factors in Computing Systems (CHI 2022) [
                  <a
                    href={withPrefix("/files/chi22_fake_video.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/m5rI7HE2Rrk"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                  <br/>
                </li> 
                <br/>

                <li className="paper">
                <a
                    href="https://dl.acm.org/doi/10.1145/3512936"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">Examining Source Effects on Perceptions of Fake News in Rural India.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Shrirang Mare, and Aditya Vashistha. <br/>
                  Proceedings of the ACM on Human-Computer Interaction (CSCW 2022) [
                  <a
                    href={withPrefix("/files/Source_Effect_CSCW.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/yd3o2SlvSoI"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]

                  <br/>
                </li>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2021</h3>
              <ul className="papers">
                <li className="paper">
                  <a
                    href={withPrefix("/files/FSH_MSc_Thesis.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Leveraging Features from EEG and Free-Hand Sketches for
                    Effective Diagnosis of Post-Traumatic Stress Disorder.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>. M.Sc. Engg.
                  Thesis, Department of Computer Science and Engineering, BUET.
                </li>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2020</h3>
              <ul className="papers">
                <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3411835"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Leveraging Free-Hand Sketches for Potential Screening of
                    PTSD.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Wasifur
                  Rahman, M. Saifur Rahman, Sharmin Akther Purabi, Ayesha
                  Seddiqa, Moin Mostakim, Farhan Feroz, Tanjir Rashid Soron,
                  Fahmida Hossain, Nabila Khan, Anika Binte Islam, Nipi Paul,
                  Ehsan Hoque, and A. B. M. Alim Al Islam. 
                  <br />
                  Proceedings of the ACM on Interactive Mobile, Wearable and
                    Ubiquitous Technologies (UBICOMP 2020) [
                  <a
                    href={withPrefix("/files/Sketch_Camera_Ready.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/-L8GdW69AFU"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                </li>
                <br />

                <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3392875"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Learning from Tweets: Opportunities and Challenges to Inform
                    Policy Making During Dengue Epidemic.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Shahinul
                  Hoque Ony, Takrim Rahman Albi, Sriram Chellappan, Aditya
                  Vashistha, and A. B. M. Alim Al Islam. <br />
                  Proceedings of the ACM on Human-Computer Interaction (CSCW 2020)
                    [
                  <a
                    href={withPrefix("/files/cscw_dengue_2020.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/Oe0fD_LwpyY"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                </li>
                <span class="sym-icon">
                  <i class="fas fa-award"></i>
                  <b> CSCW Honorable Mention Award</b>
                </span>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between">
            <div className="resume-content">
              <h3 className="mb-0">2019</h3>
              <ul className="papers">
                <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3351259"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Two Tell-tale Perspectives of PTSD: Neurobiological
                    Abnormalities and Bayesian Regulatory Network of the
                    Underlying Disorder in a Refugee Context.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid </span>, Wasifur
                  Rahman, Anika Binte Islam, Nipi Paul, Nabila Khan, Mohammad
                  Saifur Rahman, Md Munirul Haque, and A. B. M. Alim Al Islam.<br/>

                  Proceedings of the ACM on Interactive Mobile, Wearable and
                    Ubiquitous Technologies (UBICOMP 2019)[
                  <a
                    href={withPrefix("/files/FSH_IMWUT19.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] 
                </li>
                <span class="sym-icon">
                  <i class="fas fa-award"></i>
                  <b> IMWUT Distinguished Paper Award</b>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-lg-5 p-md-4 d-flex align-items-center"
        id="teaching"
      >
        <div className="w-100">
          <h2 className="mb-5">Teaching</h2>

          <h3 className="mb-3">Appointments</h3>

          
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h4 className="mb-0">Graduate Teaching Assistant</h4>
              <div className="subheading mb-1">
                Department of Information Science, Cornell University
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="text-primary">Aug 2021 - Present</span>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h4 className="mb-0">Lecturer</h4>
              <div className="subheading mb-1">
                Department of Computer Science and Engineering, Brac University
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="text-primary">May 2018 - May 2021</span>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h4 className="mb-0">Lecturer</h4>
              <div className="subheading mb-1">
                Department of Computer Science and Engineering, Eastern
                University
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="text-primary">September 2017 - April 2018</span>
            </div>
          </div>

          <h3 className="mb-3">Courses Taught</h3>

          <ul className="fa-ul p.lead">
        
            <li>
              <i className="fa-li fa fa-check"></i>
              Computer Graphics (Spring 2021, Fall 2020, Summer 2020, Spring
              2020, Fall 2019, Summer 2019, Spring 2019, Spring 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Pattern Recognition (Fall 2020, Summer 2020)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Artificial Intelligence (Spring 2020, Fall 2019)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Object Oriented Programming (Fall 2019, Summer 2019, Spring 2019,
              Fall 2018, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Digital Logic Design (Spring 2020, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Algorithms (Summer 2019, Fall 2019, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Data Structures (Summer 2019, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Operating Systems (Spring 2018, Fall 2017)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Mathematical Analysis for Computer Science (Fall 2017)
            </li>
          </ul>
          <br />
          <h3 className="mb-3">Courses Assisted</h3>
          <ul className="fa-ul mb-0">
          <li>
              <i className="fa-li fa fa-check"></i>
              Technology for Underserved Communities (Spring 2023)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Computing and Global Development (Fall 2025, Fall 2024, Spring 2024, Fall 2022, Fall 2021)
            </li>
            </ul>

            <br/>
        </div>
      </section>
    </div>
  </Layout>
);

export default Named;
